import * as types from "../actionTypes/catalogManagementUnitsAT";
import initialState from "./initialState";

export default function catalogManagementUnitsReducer(
  state = initialState.catalogManagementUnits,
  action
) {
  switch (action.type) {
    case types.CREATE_CATALOG_MANAGEMENT_UNITS:
      return [...state, { ...action.course }];
    case types.UPDATE_CATALOG_MANAGEMENT_UNITS_SUCCESS:
      return state.map((course) =>
        course.id === action.course.id ? action.course : course
      );
    case types.LOAD_CATALOG_MANAGEMENT_UNITS_SUCCESS:
      return action.catalogManagementUnits;
    case types.DELETE_CATALOG_MANAGEMENT_UNITS_OPTIMISTIC:
      return state.filter((course) => course.id !== action.course.id);
    default:
      return state;
  }
}
